<!-- FilePreviewModal.vue -->
<template>
  <b-modal size="xl" v-model="showModal" title="File Preview" hide-footer no-close-on-backdrop @hidden="modalHidden">
    <div class="file-content">
      <!-- Images: fixed frame — always contained, never natural (huge) size -->
      <img v-if="isImage" :src="fileUrl" class="file-content__img" alt=""/>
      <!-- PDFs / everything else: full width, fixed height -->
      <object v-else :data="fileUrl" :type="fileType" class="file-content__doc"></object>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }, // Use a prop to control the modal visibility
    fileUrl: String, // URL of the file content
    fileType: String, // Content type of the file (e.g., 'application/pdf')
  },
  computed: {
    isImage() {
      return (this.fileType || '').startsWith('image/');
    },
  },
  methods: {
    modalHidden() {
      this.$emit('close'); // Emit a close event to notify the parent component
    },
  },
};
</script>

<style scoped>
.file-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
.file-content__img {
  max-width: 100%;
  max-height: 70vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 6px;
}
.file-content__doc {
  width: 100%;
  height: 75vh;
}
</style>
